/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
  UTILITIES - Cookie functions
  ========================================================================== */

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/*  ==========================================================================
    UTILITIES - Shuffle Functions
  ========================================================================== */

const equalHeightShuffleItems = function (childItemSelector) {
  //selects all items
  const tiles = document.querySelectorAll(childItemSelector);

  if (!tiles) {
    return;
  }

  //puts the height of all items in an array
  let heights = [];
  tiles.forEach(tile => {
    if (tile.querySelector(".event__media")) {
      heights.push(
        tile.querySelector(".tile__content__top").clientHeight +
          tile.querySelector(".tile__content__bottom").clientHeight +
          tile.querySelector(".event__media").clientHeight
      );
    } else {
      heights.push(tile.querySelector(".tile__content").getBoundingClientRect().height);
    }
  });
  //gets the highest value out of the array
  let maxHeight = Math.max(...heights);

  //sets height of all the items to be the same as the highest one
  tiles.forEach(el => {
    el.style.height = maxHeight + "px";
  });
};

/*  ==========================================================================
    GENERAL - add linklines to links
    ========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();

linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

// Single Item toggle
const accordionToggle = document.querySelectorAll(".accordion__toggle");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      const currentState = item.getAttribute("aria-expanded");

      item.setAttribute("aria-expanded", currentState === "false");

      window.dispatchEvent(new Event("resize"));
    })
  );
}; // accordionInit();
accordionInit(accordionToggle);

// Toggle all buttons
const featureAccordion = document.querySelectorAll(".accordion__toggleall");

const featureAccordionInit = function (featureAccordion) {
  if (!featureAccordion) {
    return;
  }

  featureAccordion.forEach(toggleall => {
    const buttons = toggleall.querySelectorAll(".toggleall");

    buttons.forEach(btn => {
      btn.addEventListener("click", function () {
        const accordion = toggleall.closest(".accordion");
        if (accordion) {
          let accordionItems = accordion.querySelectorAll(".accordion__item");

          if (this.classList.contains("toggleall__expand")) {
            accordionItems.forEach(item => item.classList.add("accordion__item--open"));
          } else {
            accordionItems.forEach(item => item.classList.remove("accordion__item--open"));
          }
        }
      });
    });
  });
}; // accordionInit();
featureAccordionInit(featureAccordion);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */

const fancyboxInit = function () {
  if (!php_variables.fancyboxloaded) {
    return;
  }

  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails,
    idle: false,
    autoFocus: false,
    hideScrollbar: false,
    Carousel: {
      Navigation: false
    },
    Toolbar: {
      items: {
        infobar: {
          tpl: '<div class="fancybox__infobar" tabindex="-1"><div class="fancybox__infobarwrapper"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div></div>'
        }
      },
      display: {
        left: ["infobar"],
        middle: [],
        right: ["prev", "next", "close"]
      }
    },
    caption: function (instance, item) {
      const wrapperEl = item.triggerEl.closest(".component");
      let captionSelector = false;
      let headingSelector = false;

      if (wrapperEl) {
        captionSelector = wrapperEl.querySelector(".mediaimg__caption");
        headingSelector = wrapperEl.querySelector(".mediaimg__heading");
      }
      const caption = captionSelector ? captionSelector.textContent : "";
      const heading = headingSelector ? headingSelector.textContent : "";

      return `<div class="mediaimg__textcontent"><div class="mediaimg__heading text-sm font-bold">${heading}</div><div class="mediaimg__caption text-sm o-50">${caption}</div></div>`;
    },
    on: {
      done: (fancybox, slide) => {
        const creditSelector = slide.triggerEl.parentElement.querySelector(".mediaimg__credit");
        const credit = creditSelector ? creditSelector.textContent : "";

        if (credit) {
          slide.contentEl.innerHTML += `<div class="mediaimg__credit text-xs">${credit}</div>`;
        }

        // Setting the alt tag on images
        const imageElement = slide.el.querySelector(".fancybox__content img");

        if (slide.type === "image") {
          imageElement.setAttribute("alt", slide.alt);
        }
      },
      reveal: (fancybox, slide) => {
        lazyLoadInstance.update();
        Waypoint.refreshAll();

        diableImageRightClickInit();

        // plyrsInit();

        linksInit();

        // const videoPlayerWrapper = slide.el.querySelector(".modalvideo__video");

        // if (videoPlayerWrapper) {
        //   const player = new Plyr(videoPlayerWrapper, {
        //     controls: ["play", "progress", "mute", "current-time"],
        //     hideControls: true,
        //     invertTime: false,
        //     tooltips: { controls: false, seek: false }
        //   });

        //   player.on("ready", function () {
        //     player.play();
        //   });
        // }
      }
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Gravity Forms refresh waypoints on submit
  ========================================================================== */

const formsInit = function () {
  const forms = document.querySelectorAll(".gform_wrapper form");
  if (forms.length > 0) {
    //Only works with Jquery
    jQuery(document).ready(function () {
      jQuery(document).on("gform_confirmation_loaded", function () {
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      });
    });
  }
};
formsInit();

/*  ==========================================================================
    GENERAL - Mailchimp Newsletter signup form

    Using a mix of jquery and Vanilla as the serialize form data would not work
  ========================================================================== */

const newsletterpopup = document.querySelector(".newsletterpopup");

const subscribeResponse = document.getElementById("subscribe-response");
const preferencesResponse = document.getElementById("preferences-response");

const subscribeFormInit = function () {
  const newsletterpopupClose = document.querySelector(".newsletterpopup__close");

  if (!newsletterpopup) {
    return;
  }

  // Close modal window on esc
  window.addEventListener("keydown", function (event) {
    const newsletterPopup = document.querySelector(".newsletterpopup");

    if (event.key === "Escape" && newsletterPopup.classList.contains("show")) {
      newsletterPopup.classList.remove("show");
      newsletterPopup.setAttribute("aria-hidden", "true");

      // return focus to submit button
      const submitBtn = document.getElementById("mc-embedded-subscribe");
      if (submitBtn) {
        submitBtn.focus();
      }
    }
  });

  // Setting up the close button for the preferences popup
  newsletterpopupClose.addEventListener("click", function (e) {
    // On popup close reload the page to refresh the mailchimp for
    // as otherwise it throughs errors if using the form for a second time
    location.reload();
  });

  const subscribeForm = document.getElementById("mc-embedded-subscribe-form");
  const preferenceForm = document.getElementById("mc-embedded-preference-form");

  // Setting listener for the footer newsletter form
  subscribeForm.addEventListener("submit", function (e) {
    e.preventDefault();
    subscribeSubmitForm();
  });
  // Setting listener for the Update preferences - full subscribe form
  preferenceForm.addEventListener("submit", function (e) {
    e.preventDefault();
    preferenceFormSubmit();
  });
};
subscribeFormInit();

const subscribeSubmitForm = function () {
  var $subscribeForm = $("#mc-embedded-subscribe-form");

  const submitBtn = document.getElementById("mc-embedded-subscribe");
  submitBtn.textContent = "Sending...";

  $.ajax({
    type: "POST",
    url: $subscribeForm.attr("action"),
    data: $subscribeForm.serialize(),
    cache: false,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    error: function (err) {
      alert("Could not connect to the registration server. Please try again later.");
    },
    success: function (data) {
      submitBtn.textContent = "Subscribe";
      if (data.result === "success") {
        // Success
        var $userEmail = $subscribeForm.find("input[type='email']").val();
        subscribeShowPopup($userEmail);

        subscribeResponse.innerHTML = "";
      } else {
        // Something went wrong, do something to notify the user.
        subscribeResponse.innerHTML = "<p>" + data.msg + "</p>";
      }
    }
  });
};

const preferenceFormSubmit = function () {
  var $preferenceForm = $("#mc-embedded-preference-form");

  const preferenceBtn = document.getElementById("mc-embedded-update-preferences");
  preferenceBtn.textContent = "Updating...";

  $.ajax({
    type: "POST",
    url: $preferenceForm.attr("action"),
    data: $preferenceForm.serialize(),
    cache: false,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    error: function (err) {
      alert("Could not connect to the registration server. Please try again later.");
    },
    success: function (data) {
      preferenceBtn.textContent = "Update Preferences";

      if (data.result === "success") {
        // Yeahhhh Success
        preferencesResponse.innerHTML = "<p>" + data.msg + "</p>";
      } else {
        // Something went wrong, do something to notify the user.
        preferencesResponse.innerHTML = "<p>" + data.msg + "</p>";
      }
    }
  });
};

const subscribeShowPopup = function ($userEmail) {
  const newsletterPopup = document.querySelector(".newsletterpopup");
  newsletterPopup.classList.add("show");
  newsletterPopup.setAttribute("aria-hidden", "false");

  var $preferenceForm = $("#mc-embedded-preference-form");

  $preferenceForm.find("input[type='email']").val($userEmail);
};

/*  ==========================================================================
    GENERAL - Weglot translations
  ========================================================================== */
const languageSwitcher = document.getElementById("language__switcher");

const translationsSetSwitcher = function () {
  //Create array of options to be added
  let availableLanguages = Weglot.options.languages.map(function (language) {
    return language.language_to;
  });

  // Setting the language name

  let langName = Weglot.getLanguageName(availableLanguages[0]);
  const langLabels = document.querySelectorAll(".languagebanner__langname");
  langLabels.forEach(label => {
    label.textContent = langName;
  });

  const languageToggle = document.querySelector(".languagebanner__toggle");

  languageToggle.addEventListener("click", function () {
    if (languageToggle.dataset.lang) {
      Weglot.switchTo(languageToggle.dataset.lang);
    }
  });

  Weglot.on("languageChanged", function (lang) {
    let bannerLanguage = "";

    if (Weglot.options.language_from === lang) {
      bannerLanguage = availableLanguages[0];
    } else {
      bannerLanguage = Weglot.options.language_from;
    }
    let langName = Weglot.getLanguageName(bannerLanguage);

    const langLabels = document.querySelectorAll(".languagebanner__langname");
    langLabels.forEach(label => {
      label.textContent = langName;
    });

    languageToggle.dataset.lang = bannerLanguage;
  });
};

const translationsInit = function () {
  if (!Weglot) {
    return;
  }

  Weglot.on("initialized", translationsSetSwitcher);
};

if (languageSwitcher) {
  translationsInit();
}

/*  ==========================================================================
    GENERAL - Disable Right click on images
  ========================================================================== */

const diableImageRightClickInit = function () {
  const images = document.querySelectorAll("img");
  if (!images) {
    return;
  }

  images.forEach(img => {
    img.setAttribute("oncontextmenu", "return false");
    img.setAttribute("ondragstart", "return false");
  });
};
diableImageRightClickInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "95%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");

    if (!slides || slides.length <= 0) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    // const contentLabel = elem.dataset.contentLabel ? elem.dataset.contentLabel : 'Items';

    let movenav = true;

    let carouselIndex = 0;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: [
        "<span class='visuallyhidden'>Previous Items</span><i class='fa-light fa-arrow-left' aria-hidden='true'></i>",
        "<span class='visuallyhidden'>Next Items</span><i class='fa-light fa-arrow-right' aria-hidden='true'></i>"
      ],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      itemElement: "LI",
      stageElement: "UL",
      onInitialized: function (event) {
        // console.log("onInitialized");

        let currentCarrouselTarget = event.target;
        let currentCarrouselElem = this.$element;

        carouselIndex++;

        event.target.querySelector(".owl-stage").setAttribute("id", "owl-stage-" + carouselIndex);

        // Accesibility updates
        if (nav) {
          let nextBtn = event.target.querySelector(".owl-next");
          let prevBtn = event.target.querySelector(".owl-prev");
          nextBtn.setAttribute("aria-label", "Next Slide");
          nextBtn.setAttribute("aria-controls", "owl-stage-" + carouselIndex);
          prevBtn.setAttribute("aria-label", "Previous Slide");
          prevBtn.setAttribute("aria-controls", "owl-stage-" + carouselIndex);
        }
        if (dots) {
          let dots = event.target.querySelectorAll(".owl-dot");
          let index = 0;
          dots.forEach(function (item) {
            //Add one to index so it starts from 1
            index = index + 1;
            item.setAttribute("aria-label", "Show slide " + index);
            item.setAttribute("aria-controls", "owl-stage-" + carouselIndex);
            if (item.classList.contains("active")) {
              item.setAttribute("aria-current", true);
            }
          });
        }

        // Moving the owl-nav to before the stage for better keyboard navigation
        if (movenav && nav) {
          this.$element.children(".owl-stage-outer").prepend(this.$element.children(".owl-nav"));
          // this.$element.children(".owl-nav").classList.remove('disable')
          movenav = false;
        }

        let carouselItems = event.target.querySelectorAll(".owl-item");
        //adding the index of each item as a dataset
        carouselItems.forEach((item, index) => {
          item.dataset.index = index;
        });

        // Counting total active items
        let totalActiveItems = event.target.querySelectorAll(".owl-item.active").length - 1; // -1 as we are using offset padding so there is an active elemen that is only partly in view

        // Moves the keyboard active element into view
        window.addEventListener("keydown", function (keydownEvent) {
          if (keydownEvent.key === "Tab") {
            if (
              keydownEvent.target === currentCarrouselTarget ||
              currentCarrouselTarget.contains(keydownEvent.target)
            ) {
              let owlItem = keydownEvent.target.closest(".owl-item");

              if (owlItem.dataset.index >= totalActiveItems - 1) {
                currentCarrouselElem.trigger("to.owl.carousel", [owlItem.dataset.index, 100]);
              }
            }
          }
        });

        // lazyLoadInstance.update();
        Waypoint.refreshAll();
      },
      onTranslate: function () {
        // refreshing lazyload to target the clone images
        lazyLoadInstance.update();
      },
      onChanged: function (event) {
        // Setting the current dot
        if (dots) {
          let dots = event.target.querySelectorAll(".owl-dot");
          dots.forEach(function (item, index) {
            //Add one to index so it starts from 1
            item.setAttribute("aria-current", false);
            if (item.classList.contains("active")) {
              item.setAttribute("aria-current", true);
            }
          });
        }
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if ($(elem).height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      $(elem).trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
			Spaces Gallery Carousel
			========================================================================== */

const spacesCarousels = document.querySelectorAll(".space-gallery");

const spacesCarouselsInit = function (gridCarousels) {
  if (spacesCarousels.length <= 0) {
    return;
  }

  spacesCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".space-gallery__item");
    if (!slides) {
      return;
    }

    $(elem).owlCarousel({
      autoplay: false,
      loop: true,
      nav: false,
      dots: true,
      items: 1,
      autoHeight: false,
      itemElement: "LI",
      stageElement: "UL",
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // spacesCarouselsInit();

spacesCarouselsInit(spacesCarousels);

/*  ==========================================================================
    Featured Carousel
    ========================================================================== */

const featuredCarousel = document.querySelector(".featuredposts__slides .owl-carousel");
const autoplayTimeout = 8000;

const featuredSetAriaLabel = function (event) {
  let type = false;
  if (event.target.querySelector(".owl-item.active .slide").dataset.type) {
    type = event.target.querySelector(".owl-item.active .slide").dataset.type;
  }

  let nextBtn = event.target.querySelector(".owl-next");
  let prevBtn = event.target.querySelector(".owl-prev");
  nextBtn.setAttribute("aria-label", "Next " + type);
  prevBtn.setAttribute("aria-label", "Previous " + type);
};

const featuredStartProgressBar = function (event) {
  // apply keyframe animation
  const featuredProgress = document.querySelector(".featuredposts__progress");
  if (!featuredProgress) {
    return;
  }

  featuredProgress.style.width = "100%";
  featuredProgress.style.transition = "width " + autoplayTimeout + "ms";
};

const featuredResetProgressBar = function (event) {
  const featuredProgress = document.querySelector(".featuredposts__progress");
  if (!featuredProgress) {
    return;
  }

  featuredProgress.style.width = 0;
  featuredProgress.style.transition = "width 0s";
};

const featuredCarouselInit = function (featuredCarousel) {
  if (!featuredCarousel || featuredCarousel.length <= 0) {
    return;
  }
  const slides = featuredCarousel.querySelectorAll(".slide");
  if (!slides) {
    return;
  }

  // Optional data attribute settings
  const autoplay = true;
  const loop = true;
  const nav = true;
  const dots = false;
  const autoHeight = false;
  let autoplaying = true;
  let movenav = true;

  $(featuredCarousel).owlCarousel({
    autoplay: autoplay,
    autoplayTimeout: autoplayTimeout,
    autoplayHoverPause: true,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    loop: loop,
    nav: nav,
    navText: [
      "<span class='visuallyhidden'>Previous Items</span><i class='fa-light fa-arrow-left' aria-hidden='true'></i>",
      "<span class='visuallyhidden'>Next Items</span><i class='fa-light fa-arrow-right' aria-hidden='true'></i>"
    ],
    dots: dots,
    items: 1,
    startPosition: slides.length,
    autoHeight: autoHeight,
    slideTransition: "cubic-bezier(.25,.75,.5,.85)",
    smartSpeed: 600,
    lazyLoad: true,
    itemElement: "LI",
    stageElement: "UL",
    onInitialized: function (event) {
      // Stopping the autoplay if the user is using keyboard navigations
      window.addEventListener("keydown", function (event) {
        if (event.key === "Tab" && autoplaying) {
          $(".owl-carousel").trigger("stop.owl.autoplay");
          // Stop progress bar
          featuredResetProgressBar();
          autoplaying = false;
        }
      });

      featuredStartProgressBar();

      // Accessibility updates:

      // Moving the owl-nav to before the stage for better keyboard navigation
      if (movenav) {
        this.$element.children(".owl-stage-outer").prepend(this.$element.children(".owl-nav"));
        movenav = false;
      }

      featuredSetAriaLabel(event);
    },
    onTranslate: function (event) {
      featuredSetAriaLabel(event);
      featuredResetProgressBar();
      // Disable navigation buttons when the slide transition starts
      let prevNexts = event.target.querySelectorAll(".owl-prev, .owl-next");
      prevNexts.forEach(function (button) {
        button.classList.add("disabled");
      });

      // refreshing lazyload to target the clone images
      lazyLoadInstance.update();
    },
    onTranslated: function (event) {
      featuredSetAriaLabel(event);
      featuredStartProgressBar();
      // Re-enable navigation buttons when the slide transition completes
      let prevNexts = event.target.querySelectorAll(".owl-prev, .owl-next");
      prevNexts.forEach(function (button) {
        button.classList.remove("disabled");
      });
    }
  });

  $(featuredCarousel).on("resized.owl.carousel", function (event) {
    // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  });
};

featuredCarouselInit(featuredCarousel);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const partnerMarquee = document.querySelector(".partners__marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const partnersMarqueeInit = function () {
  if (!partnerMarquee) {
    return;
  }

  window.addEventListener("resize", function () {
    marquee__resize(partnerMarquee);
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  const tiles = partnerMarquee.querySelectorAll(".marquee__tile");
  const numTiles = tiles.length;
  const textWidth = tiles[0].offsetWidth * numTiles;

  // Had to take this out as it was causing a bug on the programmes page for screens smaller than 440
  // Leaving here incase its needed for some reason (but doesnt seem to have broken anything)
  // const timesToRepeat = Math.ceil(minWidth / textWidth);
  // const textToRepeat = partnerMarquee.innerHTML;
  // for (let index = 1; index < timesToRepeat; index++) {
  //   partnerMarquee.innerHTML += textToRepeat;
  // }

  // Wrapping the tiles
  partnerMarquee.innerHTML = "<div class='" + innerClass + "'>" + partnerMarquee.innerHTML + "</div>";

  // Duplicating the wrap element
  const repeatingTextClone = partnerMarquee.querySelector(".marquee__wrap").cloneNode(true),
    repeatingTextClone2 = partnerMarquee.querySelector(".marquee__wrap").cloneNode(true);

  repeatingTextClone.ariaHidden = "true";
  repeatingTextClone2.ariaHidden = "true";

  partnerMarquee.appendChild(repeatingTextClone);
  partnerMarquee.appendChild(repeatingTextClone2);

  // Force all lazy images within carousels to load immediately, otherwise they wont load
  // const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
  // marquee_lazyimgs.forEach(img => {
  //   LazyLoad.load(img);
  //   console.log(img);
  // });

  // Setup animation times
  marquee__resize(partnerMarquee);

  // Once everything is set up, add "loaded" class
  partnerMarquee.classList.add(elClass + "--loaded");
};

// Defer loading this code until after page load
window.addEventListener("load", partnersMarqueeInit);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  if (!mobnavToggle && !mobnav) {
    return;
  }

  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
      // Set the focus to the Mobile Nav
      let mobnavLinks = mobnav.querySelectorAll("a");
      if (mobnavLinks && mobnavLinks[0]) {
        mobnavLinks[0].focus();
      }
      mobnavToggle.setAttribute("aria-expanded", true);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);

      // Reset the focus to the toggle
      mobnavToggle.focus();

      mobnavToggle.setAttribute("aria-expanded", false);
    }
  });

  // On escape check if the mobile nav is open
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      if (body.classList.contains(mobnavOpenclass)) {
        mobnav.style.height = 0;
        body.classList.remove(mobnavOpenclass);

        // Reset the focus to the toggle
        mobnavToggle.focus();

        mobnavToggle.setAttribute("aria-expanded", false);
      }
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdowntoggle");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  let lastFocusedElement = false;

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");

      // Setting the aria label for the dropdown
      let aria = mobnavLink.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      mobnavLink.setAttribute("aria-expanded", aria);
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
    NAVIGATION - topnav dropdown escaping
    ========================================================================== */

const topnavToggles = document.querySelectorAll(".topnav__item--hasdropdown .topnav__toggle");

function topnav__init() {
  if (!topnavToggles) {
    return;
  }

  // Adding the aria expanded attribute when on hover
  topnavToggles.forEach(function (topnavToggle) {
    topnavToggle.addEventListener("click", e => {
      let expanded = topnavToggle.getAttribute("aria-expanded");
      if (expanded === "false") {
        topnavToggle.setAttribute("aria-expanded", "true");
        topnavToggle.classList.add("active");
      } else {
        topnavToggle.setAttribute("aria-expanded", "false");
        topnavToggle.classList.remove("active");
      }
    });
    // topnavitem.addEventListener("focusout", e => {
    //   link.setAttribute("aria-expanded", false);
    // });

    let topnavDropdown = topnavToggle.nextElementSibling;

    if (topnavDropdown && topnavDropdown.classList.contains("topnav__item__dropdown")) {
      topnavDropdown.addEventListener("keydown", function (event) {
        // Escaping the dropdown on tab navigation
        if (event.key === "Escape" && topnavDropdown.contains(document.activeElement)) {
          topnavToggle.setAttribute("aria-expanded", "false");
          topnavToggle.classList.remove("active");

          topnavToggle.focus();
        }

        let sectionLinks = topnavDropdown.getElementsByTagName("a");

        if (event.shiftKey && event.key === "Tab") {
          // And the first link is on focus return the focus to the toplevel item
          if (sectionLinks[0] === document.activeElement) {
            topnavToggle.setAttribute("aria-expanded", "false");
            topnavToggle.classList.remove("active");
          }
        } else if (event.key === "Tab") {
          if (sectionLinks[sectionLinks.length - 1] === document.activeElement) {
            topnavToggle.setAttribute("aria-expanded", "false");
            topnavToggle.classList.remove("active");
          }
        }
      });
    }
  });
}

topnav__init();

/*  ==========================================================================
    NAVIGATION - sitenav dropdowns
    ========================================================================== */
const siteheader = document.querySelector(".siteheader");
const sitenav = document.querySelector(".sitenav--desktop");
const sitenavitems = sitenav.querySelectorAll("li[data-dropdownsection]");
const sitenavdropdown = document.querySelector(".sitenav__dropdown");
const sitenavdropdownsections = document.querySelectorAll(".dropdownsection");

const overclass = "sitenav__item--over";
const navopenbodyclass = "sitenavopen";
const activesectionclass = "dropdownsection--active";

var navopen = false;
var currentli = false;
var dropdownclosetimer = false;
let currentTopLevelItem = false;
let nextTabItem = false;

// Check if isMobile, and only init if desktop or Ipad
if (!isMobile) {
  sitenav__init();
}

function sitenav__init() {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenavitems.forEach(function (sitenavitem) {
      sitenavitem.addEventListener("click", function (e) {
        e.preventDefault();

        if (!this.classList.contains(overclass)) {
          navopen = false;
          sitenavitem__over(sitenavitem);
        } else {
          sitenav__out();
        }
      });
    });
  } else {
    // IF DESKTOP...
    sitenavitems.forEach((sitenavitem, index) => {
      sitenavitem.addEventListener("mouseover", e => {
        sitenavitem__over(sitenavitem);
      });
      sitenavitem.addEventListener("mouseout", e => {
        sitenav__out();
      });
      // Listening for focus on the sitenav item to open the dropdown
      sitenavitem.addEventListener("focusin", e => {
        currentTopLevelItem = sitenavitem;
        currentTopLevelItem.querySelector(".sitenav__link").setAttribute("aria-expanded", true);

        if (index === sitenavitems.length - 1) {
          //if it's the last item in the nav then the next item is the search toggle
          nextTabItem = document.querySelector(".search-toggle");
        } else {
          nextTabItem = currentTopLevelItem.nextElementSibling.querySelector(".sitenav__link");
        }

        sitenavitem__over(sitenavitem);
      });

      // Listing for keydown on the sitenavitem to take the user into the the dropdown
      sitenavitem.addEventListener("keydown", function (event) {
        let dropdownsection = sitenavdropdown.querySelector(".dropdownsection--" + sitenavitem.dataset.dropdownsection);

        let sectionLinks = dropdownsection.getElementsByTagName("a");
        let firstSectionLink = sectionLinks[0];

        if (event.key === "Tab" && !event.shiftKey) {
          event.preventDefault();
          if (firstSectionLink) {
            firstSectionLink.focus();
          }
        }
      });
    });

    sitenavdropdownsections.forEach(function (dropdownsection) {
      dropdownsection.addEventListener("keydown", function (event) {
        let sectionLinks = dropdownsection.getElementsByTagName("a");

        if (event.shiftKey && event.key === "Tab") {
          // And the first link is on focus return the focus to the toplevel item
          if (sectionLinks[0] === document.activeElement) {
            event.preventDefault();
            // console.log(currentTopLevelItem);
            currentTopLevelItem.querySelector(".sitenav__link").focus();
          }
        } else if (event.key === "Tab") {
          if (sectionLinks[sectionLinks.length - 1] === document.activeElement) {
            event.preventDefault();
            sitenav__out();
            if (nextTabItem) {
              nextTabItem.focus();
            }
          }
        }
      });
    });

    sitenavdropdown.addEventListener("mouseover", e => {
      dropdownsection__over();
    });
    sitenavdropdown.addEventListener("mouseout", e => {
      sitenav__out();
    });

    sitenavdropdown.addEventListener("keydown", function (event) {
      // Escaping the dropdown on tab navigation
      if (
        event.key === "Escape" &&
        (sitenavdropdown.contains(document.activeElement) || currentTopLevelItem.contains(document.activeElement))
      ) {
        sitenav__out();
        if (nextTabItem) {
          nextTabItem.focus();
        }
      }
    });
  }
} // sitenav__init()

function sitenavitem__over(sitenavitem) {
  // On hover of sitenav item
  dropdownsection__open(sitenavitem);
} // sitenavitem__over()

function dropdownsection__open(target_li) {
  var target_section = sitenavdropdown.querySelector(".dropdownsection--" + target_li.dataset.dropdownsection);
  var dropdown_height = target_section.offsetHeight;

  let sectionLinks = target_section.querySelectorAll("a");
  let firstSectionLink = sectionLinks[0];
  let firstTimein = true;

  // Make dropdown show and set classes to say it's open
  sitenavdropdown.style.visibility = "visible";
  sitenavdropdown.style.height = dropdown_height + "px";
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to stop dropdown closing
    window.clearTimeout(dropdownclosetimer);
  }
  // Remove over class from any old clicks
  if (document.querySelector("." + overclass)) {
    document.querySelector("." + overclass).classList.remove(overclass);
  }
  // add over class to current li
  target_li.classList.add(overclass);
  document.querySelector("body").classList.add(navopenbodyclass);
  if (document.querySelector("." + activesectionclass)) {
    document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
  }
  target_section.classList.add(activesectionclass);
} //dropdownsection__open();

function dropdownsection__over() {
  // On hover of dropdownsection, keep the dropdown open
  navopen = true;
  if (dropdownclosetimer) {
    // Clear timeout to close the dropdown
    window.clearTimeout(dropdownclosetimer);
  }
  document.querySelector("body").classList.add(navopenbodyclass);
} // sitenavitem__over()

function sitenav__out() {
  // On leave sitenav hover
  navopen = false;
  //Setting responsive attribute to false
  sitenavitems.forEach(function (sitenavitem) {
    let sitenavlink = sitenavitem.querySelector(".sitenav__link");
    if (sitenavlink !== document.activeElement) {
      sitenavlink.setAttribute("aria-expanded", false);
    }
  });
  // Start timeout to close sitenav dropdown
  dropdownclosetimer = window.setTimeout(sitenav__close, 250);
} // sitenavitem__over()

function sitenav__close() {
  // when time out ends and nav open is still false, close the sitenav
  if (!navopen) {
    // Set height to 0 and remove classes
    if (document.querySelector("." + activesectionclass)) {
      document.querySelector("." + activesectionclass).classList.remove(activesectionclass);
    }
    document.querySelector("body").classList.remove(navopenbodyclass);
    if (document.querySelector("." + overclass)) {
      document.querySelector("." + overclass).classList.remove(overclass);
    }
    sitenavdropdown.style.height = 0;
    sitenavdropdown.style.visibility = "hidden";
  }
} // sitenav__close

/*  ==========================================================================
    NAVIGATION - subnav dropdowns
    ========================================================================== */

const subnav = document.querySelector(".subnav");

const subnavInit = function () {
  if (!subnav) {
    return;
  }
  const subnavToggle = subnav.querySelector(".subnav__toggle");
  subnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    subnav.classList.toggle("subnav--open");
  });
}; // subnavInit();
subnavInit();

/*  ==========================================================================
    Awards Search 
    ========================================================================== */

const awardsSearchBtn = document.querySelector(".filters__search__trigger");
const awardsSearch = document.querySelector(".filters__search");
const awardsSearchform = document.querySelector(".awardssearchform");

const awardsSearchInit = function () {
  if (!awardsSearchBtn) {
    return;
  }

  awardsSearchBtn.addEventListener("click", function (e) {
    e.preventDefault();
    awardsSearch.classList.toggle("filters__search--open");
    // Remove warning message on search close
    if (!awardsSearch.classList.contains("filters__search--open")) {
      const warningElement = awardsSearch.nextElementSibling;
      if (warningElement && warningElement.classList.contains("searchform__warning")) {
        warningElement.remove();
      }
    }
  });
}; // awardsSearchInit();

awardsSearchInit();

/*  ==========================================================================
    Awards Filters 
    ========================================================================== */

const awardsYearsToggle = document.querySelector(".filters__years__toggle");
const awardsYears = document.querySelector(".filters__years");
const awardsYearsDropdown = document.querySelector(".filters__years__dropdown");

const awardsFilterInit = function () {
  if (!awardsYearsToggle || !awardsYears) {
    return;
  }

  let lastFocusedElement = false;

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      if (awardsYears.classList.contains("open")) {
        awardsYears.classList.remove("open");
        awardsYearsToggle.setAttribute("aria-expanded", false);
        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }
    }
  });

  awardsYearsToggle.addEventListener("click", function (e) {
    e.preventDefault();
    lastFocusedElement = this;
    awardsYears.classList.toggle("open");
    let aria = awardsYearsToggle.getAttribute("aria-expanded");
    if (aria === "true") {
      aria = "false";
    } else {
      aria = "true";
    }
    awardsYearsToggle.setAttribute("aria-expanded", aria);
  });
}; // awardsSearchInit();

awardsFilterInit();

/*  ==========================================================================
    Search Filters Mobile toggle
    ========================================================================== */

const searchMobileToggle = document.querySelector(".filters__mobile__toggle");
const searchFilter = document.querySelector(".filters--search");

const searchFilterInit = function () {
  if (!searchMobileToggle || !searchFilter) {
    return;
  }

  let lastFocusedElement = false;

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      if (searchFilter.classList.contains("open")) {
        searchFilter.classList.remove("open");
        searchMobileToggle.setAttribute("aria-expanded", false);
        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }
    }
  });

  searchMobileToggle.addEventListener("click", function (e) {
    e.preventDefault();
    lastFocusedElement = this;
    searchFilter.classList.toggle("open");
    let aria = searchMobileToggle.getAttribute("aria-expanded");
    if (aria === "true") {
      aria = "false";
    } else {
      aria = "true";
    }
    searchMobileToggle.setAttribute("aria-expanded", aria);
  });
}; // searchFilterInit();

searchFilterInit();

/*  ==========================================================================
    FILTER FUNCTIONS: Used in Stories, Initiatives, in Memoriam
    ========================================================================== */

const filters = document.querySelector(".filters");
const filtersToggle = document.querySelector(".filters__dropdownbtn");
const filtersDropdown = document.querySelector(".filters__dropdown");
const filtersForm = document.querySelector(".filters__form");
const selectedOptionCounter = document.querySelector(".filters__activecount");

// Defines the url for the page that will contain the search results
const filterPageURL = filters ? filters.dataset.filterPageUrl : "";
let currentPageUrl = window.location.href.split("?")[0];

let filtersInitialLoad = true;

/*  ==========================================================================
   filterGetFormData: Gets selected options from the filter columns
    ========================================================================== */

const filterGetFormData = function () {
  let filterData = {};
  let counter = 0;

  filter_settings.filters.forEach(function (el) {
    // let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    let checkedOptions = document.querySelectorAll("input[name='" + el.name + "']:checked");
    if (checkedOptions.length > 0) {
      filterData[el.name] = [...checkedOptions].map(x => x.value);

      counter = counter + checkedOptions.length;
    }
  });

  // Updating the counter with the number of active options selected
  if (selectedOptionCounter) {
    if (filterData) {
      selectedOptionCounter.dataset.count = counter;
      selectedOptionCounter.innerHTML =
        counter > 0 ? `<span class="activecount__text o-50">${counter} SELECTED</span>` : "";
    } else {
      selectedOptionCounter.dataset.count = 0;
      selectedOptionCounter.innerHTML = "";
    }
  }

  return filterData;
};

/*  ==========================================================================
   filterUpdateURL: Updates the url with the selected values
    ========================================================================== */

const filterUpdateURL = function (filterData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  // Pagination paramters
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  if (currentPageNum && url_params === "") {
    if (url_params === "") {
      url_params = url_params + "?";
      url_params = url_params + "pagenum=" + currentPageNum;
    }
  }

  // Search parameters
  let searchParam = currentPage.searchParams.get("s");

  if (searchParam) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "s=" + searchParam;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = filterPageURL + url_params;

  if (currentPageUrl !== filterPageURL) {
    window.location.href = newUrl;
  }

  if (currentPageUrl === filterPageURL && history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  currentPageUrl = newUrl;
};

/*  ==========================================================================
   filterAddingActiveTags: Setups up the active tags in the filter bar
  ========================================================================== */

const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;

  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  if (document.querySelector(".filters__tags")) {
    // Reset tags
    document.querySelector(".filters__tags").classList.remove("filters__tags--active");
    document.querySelector(".filters__activetags__tags").innerHTML = "";
  }

  // Looping throught the filterData
  Object.keys(filterData).forEach(key => {
    const values = filterData[key];

    document
      .querySelector(".filters__fieldset[data-value='" + key + "']")
      .classList.remove("filters__fieldset--active");

    if (values.length > 0) {
      values.forEach(value => {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");

        // Setting the selected value in the inmemoriam year
        if (key === "in-memoriam-year") {
          document.querySelector(".filters__yeartoggle").text = value;
        }

        if (document.querySelector(".filters__tags")) {
          // Show active tags
          document.querySelector(".filters__tags").classList.add("filters__tags--active");
          // Add tag
          let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

          document.querySelector(
            ".filters__activetags__tags"
          ).innerHTML += `<button aria-label="remove ${filter_input_name}" class="filters__tag noline" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fa-light fa-times"></i></button>`;
        }

        hasClassActive = true;
      });
    }
  });

  return hasClassActive;
};

/*  ==========================================================================
   filterGetPosts: Calls the ajax function that retrieve the posts that match
   the selected filters
    ========================================================================== */

const filterGetPosts = function (updateURL) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;

  if (!filterData) {
    return;
  }

  filterUpdateURL(filterData);

  let activeTagsNotEmpty = filterAddingActiveTags(filterData);

  if (activeTagsNotEmpty && document.querySelector(".filters__clearall")) {
    // Only for the inmemoriam filter
    document.querySelector(".filters__clearall").classList.add("show");
  }

  if ((filtersInitialLoad && activeTagsNotEmpty) || !filtersInitialLoad) {
    filtersInitialLoad = false;

    // Scroll to filtering system
    if (document.querySelector(".filters-pin")) {
      // Adding the height of the siteheader and subnav to the math
      let siteheaderHeight = document.querySelector(".siteheader").clientHeight;
      let subnavHeight = 0;
      if (document.querySelector(".subnav")) {
        subnavHeight = document.querySelector(".subnav").clientHeight;
      }

      window.scrollTo({
        top: document.querySelector(".filters-pin").offsetTop - subnavHeight - siteheaderHeight,
        behavior: "smooth"
      });
    }

    // Start filtering
    document.querySelector(".posts.loadmore-container").classList.add("filtering");

    // Trigger ajax
    let data = {
      action: "filter",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
      page: php_variables.current_page,
      search: php_variables.search,
      filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
      filter_data: filterData
    };

    $.ajax({
      url: php_variables.ajax_url,
      data: data, // form data
      dataType: "json", // this data type allows us to receive objects from the server
      type: "POST",
      // beforeSend: function (xhr) {
      //   document.querySelector(".filters__apply").textContent = "Filtering...";
      // },
      success: function (data) {
        // when filter applied:
        // set the current page to 1
        php_variables.current_page = 1;

        // set the new query parameters
        php_variables.posts = data.posts;

        // set the new max page parameter
        php_variables.max_page = data.max_page;

        // hide load more button, if there are not enough posts for the second page

        const pagingLoadmore = document.querySelector(".paging__loadmore");
        if (pagingLoadmore) {
          if (data.max_page < 2) {
            pagingLoadmore.style.display = "none";
          } else {
            pagingLoadmore.style.display = "block";
          }
        }

        // insert the posts to the container
        const loadmoreContainer = document.querySelector(".posts.loadmore-container");
        if (loadmoreContainer) {
          loadmoreContainer.innerHTML = data.content;
          // Finish filtering
          loadmoreContainer.classList.remove("filtering");
        }

        setFilterTagsListeners();

        //Refreshing animations effects
        setTimeout(function () {
          Waypoint.refreshAll();
        }, 500);

        lazyLoadInstance.update();
      },
      error: function (data) {}
    });
  }
};

/*  ==========================================================================
   setFilterTagsListeners: Adds listeners to the active filter tags
    ========================================================================== */

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll("button.filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function (e) {
      e.preventDefault();

      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();

      // Returning focus to the toggle
      if (filtersToggle) {
        filtersToggle.focus();
      }
    });
  });
};

/*  ==========================================================================
   filterSetupClearAll: Clears all filters and removes tags
    ========================================================================== */

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelector(".filters__clearall");

  if (!filterClearAll) {
    return;
  }

  filterClearAll.addEventListener("click", function (e) {
    e.preventDefault();

    //If there is tags
    if (document.querySelector(".filters__tags")) {
      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
    }

    //if It's the inmemorium filter reset year select
    const yearToggle = document.querySelector(".filters__yeartoggle");
    if (yearToggle) {
      yearToggle.text = "Select";
    }

    // Uncheck all inputs
    const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
    filterCheckboxes.forEach(el => (el.checked = false));

    // Updating the selected options counter
    if (selectedOptionCounter) {
      selectedOptionCounter.dataset.count = 0;
      selectedOptionCounter.innerHTML = "";
    }

    // Trigger filter
    filterGetPosts();

    filterClearAll.classList.remove("show");

    filterCloseDropdown(filtersToggle);
  });
};

/*  ==========================================================================
   In Memory of filter: Allow the user to skip the alphabet selection and tab
   through the content
    ========================================================================== */

const skipAlphabetFilter = document.querySelector(".skip__alphabet__filter");
const alphabetFilterOptions = document.querySelectorAll(
  ".inmemoriam__filter__alphabet .filters__fieldset__field input"
);
const filtersClearAll = document.querySelector(".filters__clearall.show");
const postsInmemoriamLinks = document.querySelectorAll(".posts--inmemoriam .tile__link");

const alphabetFilterSkipInit = function () {
  if (!skipAlphabetFilter) {
    return;
  }
  skipAlphabetFilter.addEventListener("click", function (e) {
    e.preventDefault();
    alphabetFilterOptions.forEach(el => {
      el.tabIndex = -1;
    });

    if (filtersClearAll) {
      filtersClearAll.focus();
    } else {
      if (postsInmemoriamLinks && postsInmemoriamLinks[0]) {
        postsInmemoriamLinks[0].focus();
      }
    }
  });
};

alphabetFilterSkipInit();

/*  ==========================================================================
   filterCloseDropdown: Closes the dropdown
    ========================================================================== */

const filterCloseDropdown = function (lastFocusedElement) {
  if (filters && filtersForm && filters.classList.contains("filters--dropdownopen")) {
    filters.classList.remove("filters--dropdownopen");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
    if (!filters.classList.contains("filters--in-memoriam")) {
      filtersForm.hidden = true;
    }
  }
};

/*  ==========================================================================
   filterInit: Initialise the filtering functions when there is a filter
   available
    ========================================================================== */

const filterInit = function () {
  if (
    !filters ||
    filters.classList.contains("filters--awards") ||
    filters.classList.contains("filters--connectdirectory")
  ) {
    return;
  }
  // Get Posts based on Filter Form Data
  if (currentPageUrl === filterPageURL) {
    filterGetPosts();
  }

  const filtersOptions = filters.querySelectorAll(
    ".filters__fieldset__field:not(.filters__fieldset__field--notrigger) input"
  );

  let lastFocusedElement = false;

  // Setting up on esc listener if the drowdown is open to close modal
  // and return focus to toggle
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      filterCloseDropdown(lastFocusedElement);
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
      if (!event.target.closest(".filters__dropdown") && !event.target.classList.contains("filters__dropdownbtn")) {
        filterCloseDropdown(lastFocusedElement);
      }
    },
    false
  );

  const cancelBtn = filters.querySelector(".actions__cancel");
  if (cancelBtn) {
    cancelBtn.addEventListener("click", function (e) {
      e.preventDefault();

      filterCloseDropdown(lastFocusedElement);
    });
  }

  // Dropdown open & close
  if (filtersToggle) {
    filtersToggle.addEventListener("click", function (e) {
      e.preventDefault();

      filters.classList.toggle("filters--dropdownopen");
      filtersForm.hidden = false;

      if (filters.classList.contains("filters--dropdownopen")) {
        // Store the last focused element
        lastFocusedElement = document.activeElement;

        // Putting the focus on the first input on the list
        if (filtersOptions && filtersOptions[0]) {
          filtersOptions[0].focus();
        }
      }
      // Setting the aria label for the dropdown
      let aria = filtersToggle.getAttribute("aria-expanded");

      if (aria === "true") {
        aria = "false";
      } else {
        aria = "true";
      }
      filtersToggle.setAttribute("aria-expanded", aria);
    });
  }

  //If the filter has the selected option counter

  if (selectedOptionCounter) {
    let currentCount = false;

    const nonTriggerfiltersOptions = filters.querySelectorAll(".filters__fieldset__field--notrigger input");
    nonTriggerfiltersOptions.forEach(option => {
      option.addEventListener("change", function (evt) {
        currentCount = selectedOptionCounter.dataset.count;

        if (currentCount) {
          // console.log(this);
          // console.log(currentCount);

          if (this.checked) {
            currentCount++;
          } else {
            currentCount--;
          }

          selectedOptionCounter.dataset.count = currentCount;

          selectedOptionCounter.innerHTML =
            currentCount > 0 ? `<span class="activecount__text o-50">${currentCount} SELECTED</span>` : "";
        }
      });
    });
  }

  // Filter on submit
  if (filtersForm) {
    filtersForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      if (currentPageUrl !== filterPageURL) {
        let filterData = filterGetFormData();

        // Update url
        filterUpdateURL(filterData);
      } else {
        // Call the filtering post function
        filterGetPosts(true);
        filters.classList.toggle("filters--dropdownopen");
        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }

        // If we are in the search and it's mobile close filter options
        if (searchFilter) {
          searchFilter.classList.remove("open");
        }
      }
    });
  }

  filtersOptions.forEach(option => {
    option.addEventListener("change", function (evt) {
      // Set up for checkbox group that only admits one item checked at the time
      if (this.dataset.type && this.dataset.type === "single") {
        let name = this.getAttribute("name");

        // If we are removing the only active option and it's In memoriam Year the reset selected value
        if (this.checked === false && name === "in-memoriam-year") {
          //if It's the inmemorium filter reset year select
          const yearToggle = document.querySelector(".filters__yeartoggle");
          if (yearToggle) {
            yearToggle.text = "Select";
          }
        }

        const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input[name=" + name + "]");
        filterCheckboxes.forEach(el => {
          if (el !== this) {
            el.checked = false;
          }
        });
      }

      // Checks if we are in the filter page or is the content module that should take us to the main listing for the PT
      if (currentPageUrl !== filterPageURL) {
        let filterData = filterGetFormData();

        // Update url
        filterUpdateURL(filterData);
      } else {
        // Call the filtering post function
        filterGetPosts(true);
        // Close the filters dropdown
        filterCloseDropdown(lastFocusedElement);

        // If we are in the search and it's mobile close filter options
        if (searchFilter) {
          searchFilter.classList.remove("open");
        }
      }
    });
  });

  // Remove tags on click
  setFilterTagsListeners();

  // Clear all
  filterSetupClearAll();
};

filterInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page,
        search: php_variables.search
      };

      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    search: php_variables.search,
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        // Saving the last item before new data added
        let loadmoreContainerItems = loadmoreContainer.querySelectorAll(".col");
        let nextFocusIndex = loadmoreContainerItems.length;

        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }

        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // Focusing on the first item from the new set of items
        if (nextFocusIndex) {
          loadmoreContainerItems = loadmoreContainer.querySelectorAll(".col");
          if (
            loadmoreContainerItems[nextFocusIndex] &&
            loadmoreContainerItems[nextFocusIndex].querySelector(".tile__link")
          ) {
            loadmoreContainerItems[nextFocusIndex].querySelector(".tile__link").focus();
          }
        }
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    },
    error: function (error) {
      console.log("error");
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    ACCESSIBILITY - Reduce Motion Options
    ========================================================================== */

const accessiblityReduceMotion = function (isReduceMotionOn = false) {
  if (isReduceMotionOn === "true") {
    // Set Cookie
    setCookie("reduce-animation", true, 7);
    //Stop autoplaying video

    // Stop owl carousels '.featuredposts__slides' is the only autoplaying carousel
    $(".owl-carousel").trigger("stop.owl.autoplay");
    // Stop progress bar
    featuredResetProgressBar();
  } else {
    //Turn everything back on remove cookie
    setCookie("reduce-animation", false, 7);

    // Play autoplaying owl carousels
    $(".featuredposts__slides .owl-carousel").trigger("play.owl.autoplay", [8000]);
    featuredStartProgressBar();
  }
};

/*  ==========================================================================
    ACCESSIBILITY - Options init
    ========================================================================== */

let accesibilityLastFocusedElement = false;

const accessiblityOptionsInit = function () {
  const accessibilityOpensettings = document.querySelector(".accessibility__opensettings");
  const accessibilityToggle = document.querySelector(".accessibility__toggle");

  const accessibilityOptions = document.querySelector(".accessibility__options");

  accessibilityToggle.addEventListener("click", function (e) {
    e.preventDefault();
    accessibilityOptions.classList.toggle("open");

    const currentState = accessibilityToggle.getAttribute("aria-expanded");

    accessibilityToggle.setAttribute("aria-expanded", currentState === "false");
  });

  accessibilityOpensettings.addEventListener("click", function (e) {
    e.preventDefault();

    accesibilityLastFocusedElement = document.activeElement;
    if (accessibilityToggle) {
      accessibilityToggle.focus();
      accessibilityToggle.click();
    }
  });

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && accessibilityOptions.classList.contains("open")) {
      accessibilityOptions.classList.remove("open");

      if (accesibilityLastFocusedElement) {
        accesibilityLastFocusedElement.focus();
        accesibilityLastFocusedElement = false;
      }
    }
  });

  const accessibilityOptionToggle = document.querySelectorAll(".accessibility__option__toggle");

  accessibilityOptionToggle.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const currentState = btn.getAttribute("aria-checked");

      btn.setAttribute("aria-checked", currentState === "false");

      let action = btn.dataset.action;

      // adding the action as a class
      document.body.classList.toggle(action);

      if (action === "reduce-animation") {
        accessiblityReduceMotion(btn.getAttribute("aria-checked"));
      }
    });
  });
}; // sharingLinksInit();
accessiblityOptionsInit();

/*  ==========================================================================
	SEARCH - Header Navigation
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");
const searchForm = document.querySelector(".siteheader__search .searchform");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; //clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  accesibilityLastFocusedElement = document.activeElement;

  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    if (searchForm) {
      searchForm.focus();
    }
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav || !searchToggle) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);

  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && searchNav.classList.contains("siteheader__search--open")) {
      searchNav.classList.remove("siteheader__search--open");

      if (accesibilityLastFocusedElement) {
        accesibilityLastFocusedElement.focus();
        accesibilityLastFocusedElement = false;
      }
    }
  });
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
	SEARCH, All Forms - Form Validation
	========================================================================== */
const searchFormAll = document.querySelectorAll(".searchform");

const searchFormWarningInit = function () {
  if (!searchFormAll) {
    return;
  }

  searchFormAll.forEach(function (form) {
    // Select the input containers
    const inputContainer = form.querySelector(".searchform__input") || form.querySelector(".filters__search__field");
    if (!inputContainer) {
      return;
    }

    const input = inputContainer.querySelector("input");

    // Remove the `required` and `minlength` attributes to prevent browser validation
    input.removeAttribute("required");
    input.removeAttribute("minlength");

    // Create the warning message dynamically
    const warning = document.createElement("div");
    warning.classList.add("searchform__warning");
    warning.textContent = "Please lengthen the search to 3 or more characters.";
    // Make the warning accessible for screen readers
    warning.setAttribute("role", "alert");
    warning.setAttribute("aria-live", "assertive");
    warning.setAttribute("aria-hidden", "true");

    let warningAddedToForm = false;

    form.addEventListener("submit", function (e) {
      if (input.value.trim().length === 0 || input.value.trim().length < 3) {
        e.preventDefault(); // Stop form submission
        form.appendChild(warning); // Append after the input container
        warningAddedToForm = true;
        input.setAttribute("aria-invalid", "true"); // Mark the input as invalid
        input.focus();
      } else {
        input.setAttribute("aria-invalid", "false"); // Remove aria-invalid if valid
        if (warningAddedToForm) {
          form.removeChild(warning);
          warningAddedToForm = false;
        }
      }
    });

    input.addEventListener("input", function () {
      if (input.value.trim().length >= 3) {
        input.setAttribute("aria-invalid", "false"); // Mark the input as valid
        if (warningAddedToForm) {
          form.removeChild(warning);
          warningAddedToForm = false;
        }
      }
    });
  });
};

searchFormWarningInit();

/*  ==========================================================================
    Events - Events Filter

    The events filtering uses Shuffle, as events are loaded from an external
    source as json data
  ========================================================================== */

const eventsFilter = document.querySelector(".events__filter");
const eventsShuffleContainer = document.querySelector(".events .events__list");

const eventsFilterEvents = function () {
  let activeOptions = false;
  const currentSelectOptions = [];

  const eventsFilterOptions = document.querySelectorAll(".filters--events .filter__option");

  eventsFilterOptions.forEach(el => {
    if (el.classList.contains("active") && el.dataset.option !== "") {
      currentSelectOptions.push(el.dataset.option);
      activeOptions = true;
    }
  });

  if (activeOptions === true) {
    const eventsClearAll = document.querySelector(".filter__clearall");
    eventsClearAll.classList.add("show");
  }

  shuffleInstance.filter(currentSelectOptions);
};

/*  ==========================================================================
    Events - Events Feed
  ========================================================================== */

const eventsFeed = document.getElementById("eventsfeed");

let shuffleInstance = false;

const eventsFeedInit = function () {
  if (!eventsFeed) {
    return;
  }

  equalHeightShuffleItems(".tile--event");

  window.addEventListener("resize", event => {
    equalHeightShuffleItems(".tile--event");
  });

  shuffleInstance = new Shuffle(eventsShuffleContainer, {
    itemSelector: ".tile__selector",
    filterMode: Shuffle.FilterMode.ANY,
    delimiter: ",",
    sizer: ".tile__sizer"
  });

  const eventsClearAll = document.querySelector(".filter__clearall");

  if (eventsClearAll) {
    eventsClearAll.addEventListener("click", function (e) {
      e.preventDefault();

      eventsFilterOptions.forEach(option => {
        if (option.classList.contains("active")) {
          option.classList.remove("active");
        }
      });
      shuffleInstance.filter();
      eventsClearAll.classList.remove("show");
    });
  }

  const eventsFilterOptions = document.querySelectorAll(".filters--events .filter__option");

  if (eventsFilterOptions) {
    eventsFilterOptions.forEach(option => {
      option.addEventListener("click", function (e) {
        e.preventDefault();

        if (this.classList.contains("active")) {
          // it's already active
          return;
        }

        // Removing any other otions selected
        eventsFilterOptions.forEach(el => {
          el.classList.remove("active");
        });

        this.classList.add("active");

        eventsFilterEvents();
      });
    });
  }
};

//eventsFeedInit();

/*  ==========================================================================
  Connect Directory - Filter

  The Connect Directory filtering uses Shuffle, as records are loaded from an external
  source and store as json data
========================================================================== */

const connectDirectoryFilter = document.querySelector(".connectdirectory__filter");
const connectDirectoryShuffleContainer = document.querySelector(".connectdirectory__records");
const connectDirectoryTiles = document.querySelectorAll(".tile__selector");
const connectdirectoryActiveTags = document.querySelector(".connectdirectory__activetags");

let activefilters = {
  expertise: [],
  location: []
};

const connectDirectoryRunFilter = function () {
  let activeOptions = false;
  const currentSelectOptions = [];

  connectDirectoryShuffleContainer.classList.add('working');

  const connectDirectoryFilterOptions = document.querySelectorAll(".filters--connectdirectory .filter__option");

  const connectDirectoryLocationOptions = document.querySelectorAll(".location__options .filter__option");
  const connectDirectoryExpertiseOptions = document.querySelectorAll(".expertise__options .filter__option");

  activefilters.expertise = Array.from(connectDirectoryExpertiseOptions)
    .filter(el => el.classList.contains("active") && el.dataset.option)
    .map(el => el.dataset.option);

  activefilters.location = Array.from(connectDirectoryLocationOptions)
    .filter(el => el.classList.contains("active") && el.dataset.option)
    .map(el => el.dataset.option);

  let activeTags = "";
  connectDirectoryFilterOptions.forEach(el => {
    if (el.classList.contains("active") && el.dataset.option !== "") {
      //Adding active tags
      let activeTagHTML =
        '<li class""><button aria-label="remove ' +
        el.textContent +
        '" class="active__tag" data-option="' +
        el.dataset.option +
        '"> ' +
        el.textContent +
        ' <i class="fa-light fa-times"></i></button></li>';

      activeTags += activeTagHTML;
    }
  });
  if (activeTags !== "") {
    connectdirectoryActiveTags.innerHTML =
      '<div class="connectdirectory__activetags__wrap"><span class="o-50 text-sm">Showing:</span><ul class="connectdirectory__activetags__tags">' +
      activeTags +
      "</ul></div>";
  } else {
    connectdirectoryActiveTags.innerHTML = "";
  }

  // Running Filter
  // Hide all elements that do not match
  let matchingTiles = [];
  connectDirectoryTiles.forEach(tile => {
    // Expertise
    let expertiseArray = tile.dataset.expertise.split(",");
    let tileMatchesExpertise = false;
    if (activefilters.expertise.length > 0) {
      if (tile.dataset.expertise !== "") {
        let matches = activefilters.expertise.diff(expertiseArray);
        if (matches.length > 0) {
          tileMatchesExpertise = true;
          matchingTiles.push(tile);
        }
      }
    } else {
      tileMatchesExpertise = true;
    }

    // Location
    let locationArray = tile.dataset.location.split(",");

    let tileMatchesLocation = false;

    if (activefilters.location.length > 0) {
      if (tile.dataset.location !== "") {
        let matches = activefilters.location.diff(locationArray);
        if (matches.length > 0) {
          tileMatchesLocation = true;
        }
      }
    } else {
      tileMatchesLocation = true;
    }

    // Search
    const searchInput = document.querySelector(".connectdirectory__search__input");
    const searchText = searchInput.value.toLowerCase();
    let tileMatchesSearch = false;

    if (searchInput && searchInput !== "") {
      const titleElement = tile.querySelector(".tile__heading");
      const titleText = titleElement.textContent.toLowerCase().trim();

      if (titleText.includes(searchText)) {
        tileMatchesSearch = true;
      }
    } else {
      tileMatchesSearch = true;
    }

    // Hide/Show tile if it matches the filter
    if (tileMatchesSearch && tileMatchesLocation && tileMatchesExpertise) {
      tile.style.display = "block";
    } else {
      tile.style.display = "none";
    }
  });

  setTimeout(function() {
    connectDirectoryShuffleContainer.classList.remove('working');
  }, 500);
};

/*  ==========================================================================
   Helper function that compares two arrays
    ========================================================================== */
Array.prototype.diff = function (arr2) {
  var ret = [];
  this.sort();
  arr2.sort();
  for (var i = 0; i < this.length; i += 1) {
    if (arr2.indexOf(this[i]) > -1) {
      ret.push(this[i]);
    }
  }
  return ret;
};

/*  ==========================================================================
   setFilterTagsListeners: Adds listeners to the active filter tags
    ========================================================================== */

const setActiveTagsListeners = function () {
  connectdirectoryActiveTags.addEventListener("click", function (e) {
    if (e.target.classList.contains("active__tag")) {
      let option = e.target.dataset.option;
      let activeElement = document.querySelector(
        ".filters--connectdirectory .filter__option[data-option='" + option + "']"
      );
      activeElement.classList.remove("active");

      connectDirectoryRunFilter();
    }

    // Returning focus to the toggle
    if (connectDirectoryFilter) {
      connectDirectoryFilter.focus();
    }
  });
};

/*  ==========================================================================
    Connect Directory - Shuffle Init function
  ========================================================================== */

const connectDirectory = document.getElementById("connectdirectory");
const connectDirectoryToggle = document.querySelectorAll(".connectdirectory__toggle");

let connectshuffleInstance = false;
let connectLastFocusedElement = false;

const connectDirectoryInit = function () {
  if (!connectDirectory) {
    return;
  }

  equalHeightShuffleItems(".tile--connectdirectory");

  // Setting up on esc listener if the drowdown is open to close modal
  // and return focus to toggle
  window.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Escape key pressed
      connectDirectoryToggle.forEach(el => {
        if (el.closest(".connectdirectory__filtersection").classList.contains("open")) {
          el.closest(".connectdirectory__filtersection").classList.remove("open");
          if (connectLastFocusedElement) {
            connectLastFocusedElement.focus();
          }
        }
      });
    }
  });

  // Dropdown open & close
  if (connectDirectoryToggle) {
    connectDirectoryToggle.forEach(el => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        el.closest(".connectdirectory__filtersection").classList.toggle("open");

        if (el.closest(".connectdirectory__filtersection").classList.contains("open")) {
          // Store the last focused element
          connectLastFocusedElement = document.activeElement;

          let openFilterOptions = el.closest(".connectdirectory__filtersection").querySelectorAll(".filter__option");

          // Putting the focus on the first input on the list
          if (openFilterOptions && openFilterOptions[0]) {
            openFilterOptions[0].focus();
          }
        }
        // Setting the aria label for the dropdown
        let aria = el.getAttribute("aria-expanded");

        if (aria === "true") {
          aria = "false";
        } else {
          aria = "true";
        }
        el.setAttribute("aria-expanded", aria);
      });
    });
  }

  const connectFilterOptions = document.querySelectorAll(".filters--connectdirectory .filter__option");

  if (connectFilterOptions) {
    connectFilterOptions.forEach(option => {
      option.addEventListener("click", function (e) {
        e.preventDefault();

        this.classList.toggle("active");

        connectDirectoryRunFilter();
      });
    });
  }

  // Search input
  const connectFilterSearch = document.querySelector(".connectdirectory__search__form");

  connectFilterSearch.addEventListener("submit", function (e) {
    e.preventDefault();
    connectDirectoryRunFilter();
  });

  if (connectdirectoryActiveTags) {
    setActiveTagsListeners();
  }
};

connectDirectoryInit();
